const BACKEND_SERVER_URL = process.env.REACT_APP_PATIENT_SERVER_URL
const LICENCE_URL = process.env.REACT_APP_LICENCE_URL
const API_KEY = "?key=" + process.env.REACT_APP_TDS_API_KEY
const LICENCE_KEY = "?key=" + process.env.REACT_APP_TDS_LICENCE_API_KEY

export const PWR_APIS = {
    GET_SAVE_PATIENT: BACKEND_SERVER_URL + "generic" + API_KEY,
    VALIDATE_LICENCE : LICENCE_URL + "validate" + LICENCE_KEY
}

